import { useState, useEffect } from 'react';

export const usePWAInstall = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [isInstallable, setIsInstallable] = useState(false);
    const [isIOS, setIsIOS] = useState(() => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        const isIpad = /macintosh/i.test(userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
        return /iphone|ipad|ipod/.test(userAgent) || isIpad;
    });
    
    const [isStandalone, setIsStandalone] = useState(() => {
        return window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;
    });

    useEffect(() => {
        // Listen for standard Android/Desktop beforeinstallprompt
        const handler = (e: Event) => {
            e.preventDefault(); // Prevent automatic mini-infobar
            setDeferredPrompt(e);
            setIsInstallable(true);
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    const promptInstall = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            setIsInstallable(false);
        }
        setDeferredPrompt(null);
    };

    return { isInstallable, isIOS, isStandalone, promptInstall };
};
